import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteWishListApiCallMagento } from '../apis/wish-list-delete.api';

export const deleteWishList = createAsyncThunk(
  'wishList/delete',
  async (wishListId: number) => {
  return await deleteWishListApiCallMagento(wishListId);
}, {
  condition: ((_arg, {getState} )=>{
    const state = getState() as StoreState;
    return state.wishListState.deleteWishList.status !== ActionStatus.loading;
  })
});
